module.exports = __webpack_public_path__ + "img/Front_seats.d5d8d7b2.jpg";